import { useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { useT } from "@/lib/i18n";

/** İlk eşleşen kazanır: sabit segmentler (`/events/new`) parametreli olanlardan önce. */
const ROUTE_TITLES: ReadonlyArray<readonly [pattern: string, key: string]> = [
  ["/", "home"],
  ["/login", "login"],
  ["/signup", "signup"],
  ["/forgot-password", "resetPassword"],
  ["/reset-password", "resetPassword"],
  ["/check-email", "verifyEmail"],
  ["/verify-email", "verifyEmail"],
  ["/accept-invite", "acceptInvite"],
  ["/forbidden", "forbidden"],
  ["/onboarding", "onboarding"],
  ["/shops", "shops"],
  ["/shops/new", "newShop"],
  ["/shops/:slug", "shop"],
  ["/events", "events"],
  ["/events/new", "newEvent"],
  ["/events/:slug", "event"],
  ["/orders", "orders"],
  ["/orders/:orderNumber", "order"],
  ["/promotions", "promotions"],
  ["/promotions/new", "newPromotion"],
  ["/promotions/:id", "promotion"],
  ["/check-in", "checkIn"],
  ["/team", "team"],
  ["/reports", "reports"],
  ["/reports/events", "eventReports"],
  ["/reports/events/:eventId", "eventReport"],
  ["/finance", "finance"],
  ["/audit", "audit"],
  ["/settings", "settings"],
  ["/settings/legal", "legal"],
];

function setDocumentTitle(title: string) {
  document.title = `${title} · TicketNjoy`;
}

export function DocumentTitle() {
  const { pathname } = useLocation();
  const t = useT("titles");
  const key = ROUTE_TITLES.find(([pattern]) => matchPath(pattern, pathname))?.[1] ?? "notFound";
  const title = t(key);

  useEffect(() => {
    setDocumentTitle(title);
  }, [title]);

  return null;
}
